import { locales, DEFAULT_LOCALE } from '@flex-packages/i18n-base';

const _FetchI18nResources = class _FetchI18nResources {
  constructor(localeFileExtension = _FetchI18nResources.DEFAULT_LOCALE_FILE_EXTENSION) {
    this.localeFileExtension = localeFileExtension;
  }
  /**
   * requireContext로부터 번역어 리소스를 조합하여 생성
   */
  exec(requireContext) {
    const resources = Object.fromEntries(
      locales.map((locale) => [locale])
    );
    return requireContext.keys().reduce((accumulator, key) => {
      const data = requireContext(key);
      const locale = this.findLocale(key);
      const namespace = this.findNamespace(
        key,
        this.localeFileExtension,
        locale
      );
      Object.assign(accumulator, {
        [locale]: Object.assign(accumulator[locale] || {}, {
          [namespace]: data
        })
      });
      return accumulator;
    }, resources);
  }
  /**
   * 로케일 파일의 경로로부터 namespace를 추출
   * @param {string} key - 로케일 파일의 경로
   * @param {string} suffix - 로케일 파일의 확장자
   * @param {string=} locale - 해당 키의 로케일, 입력이 없으면 직접 추출
   */
  findNamespace(key, suffix, locale) {
    const { DEFAULT_NAMESPACE, PATH_DELIMITER } = _FetchI18nResources;
    const currentPathDelimiter = PATH_DELIMITER.exec(key)?.[0];
    if (!currentPathDelimiter) {
      return DEFAULT_NAMESPACE;
    }
    const candidates = key.split(currentPathDelimiter);
    const localeIndex = candidates.indexOf(locale || this.findLocale(key));
    const namespace = candidates.slice(localeIndex + 1).join(currentPathDelimiter).replace(suffix, "");
    if (!namespace) {
      return DEFAULT_NAMESPACE;
    }
    return namespace;
  }
  /**
   * 로케일 파일의 경로에서 로케일 정보를 추출
   * @param {string} key - 로케일 파일의 경로
   */
  findLocale(key) {
    const { PATH_DELIMITER } = _FetchI18nResources;
    const candidates = key.split(PATH_DELIMITER);
    const found = locales.find((locale) => candidates.includes(locale));
    return found || DEFAULT_LOCALE;
  }
};
/**
 * locale 파일 확장자를 지정할 수 있음
 */
_FetchI18nResources.DEFAULT_LOCALE_FILE_EXTENSION = ".json";
/**
 * - i18next의 기본 namespace
 * - 탐색 실패 시 이것으로 사용
 * - 이 부분은 오버라이드할 여지가 없음
 */
_FetchI18nResources.DEFAULT_NAMESPACE = "translation";
/**
 * - 경로 구분자
 * - 이 부분은 오버라이드할 여지가 없음
 */
_FetchI18nResources.PATH_DELIMITER = /\\|\//;
let FetchI18nResources = _FetchI18nResources;

export { FetchI18nResources };
//# sourceMappingURL=FetchI18nResources.mjs.map
